import { ILLUSTRATION_SIZE } from "../illustration/Illustration.js";
import illustrationcard_module_default from "./illustrationcard.module.js";
import { BareCard, Box, ElevatedCard, FilledCard, Flex, OutlinedCard, Stack } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/illustration-card/IllustrationCard.tsx
const variants = {
	bare: BareCard,
	elevated: ElevatedCard,
	filled: FilledCard,
	outlined: OutlinedCard,
	highlighted: FilledCard
};
const flexDirection = {
	left: "row",
	right: "row-reverse",
	top: "column"
};
const IllustrationCard = ({ children, header, Illustration, illustrationPosition = "left", illustrationSize = "sm", variant, withShadow = true, ...restProps }) => {
	const Card = variants[variant];
	const color = restProps.color ?? "primary";
	const shade = variant === "filled" ? 1 : 0;
	const style = {
		flexDirection: `var(--illustration-card-flex-dir, ${flexDirection[illustrationPosition]})`,
		justifyContent: "var(--illustration-card-justify, normal)"
	};
	return /* @__PURE__ */ jsx(Card, {
		...restProps,
		withBorder: variant === "filled",
		children: /* @__PURE__ */ jsxs(Flex, {
			align: "center",
			gap: "sm",
			style,
			classNames: { root: illustrationcard_module_default[`flexRoot${illustrationSize}`] },
			children: [/* @__PURE__ */ jsxs(Box, {
				className: illustrationcard_module_default.illustrationWrapper,
				__vars: {
					"--illustration-bg": withShadow ? `var(--mantine-color-${color}-${shade})` : "transparent",
					"--illustration-size": ILLUSTRATION_SIZE[illustrationSize]
				},
				children: [/* @__PURE__ */ jsx(Illustration, { size: illustrationSize }), /* @__PURE__ */ jsx(Box, { className: illustrationcard_module_default.illustrationShadow })]
			}), /* @__PURE__ */ jsxs(Stack, {
				className: illustrationcard_module_default.cardContent,
				gap: "xs",
				children: [header, children]
			})]
		})
	});
};

//#endregion
export { IllustrationCard };